// extracted by mini-css-extract-plugin
module.exports = {"admin":"AdminItem_admin__6mcZ2","text":"AdminItem_text__2vt4w","link":"AdminItem_link__3RvRu"};